import { createSlice } from '@reduxjs/toolkit';

export const scheduleSlice = createSlice({
  name: 'schedule',
  initialState: {
    schedule: [],
  },
  reducers: {
    addSchedule: (state, action) => {
      state.schedule = action.payload
    },
  },
});

export const { addSchedule } = scheduleSlice.actions;

export const selectSchedule = state => state.schedule.schedule;

export default scheduleSlice.reducer;
